import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { trimSlashAtTheEnd } from 'businessLogic/selfProvision.js';
import Txt from '../../../inputs/textInput.js';
import { Checkbox } from 'semantic-ui-react';
import { getWaitingAreaNameToShortURL } from '../../../../businessLogic/selfProvision';
var passwordValidator = require('../../../../businessLogic/resetPasswordValidation');
import { setWASelfProvisionForm, setWASelfProvisionFormTrim } from '../../../../actions/waitingArea.js';
import { updateShowWelcomeWAMessage } from '../../../../actions/modal';
import { createSelfProvisionWA } from '../../../../actions/waitingArea';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { redirectToInternalLink } from 'businessLogic/redirector.js';
import objectAssign from 'object-assign';
import momentTimezone from 'moment-timezone/builds/moment-timezone-with-data-2012-2022.min';
import { setAuthenticationDetails } from '../../../../businessLogic/authorizator.js';

export default function ContentSelfProvisionWA(props) {
  const dispatch = useDispatch();
  const selfProvisionCreateForm = useSelector((state) => state.waitingAreaReducer.selfProvisionCreateForm);
  const [isWASelfProvisionSaving, setIsWASelfProvisionSaving] = useState(false);
  const [isOnMobileOrTablet, setIsOnMobileOrTablet] = useState(
    window.innerWidth < window.styleVariable.computerMinWidth
  );
  const spaceBWFields = 'mrtl';
  const orgNameAbbRef = useRef(null);
  const waitingAreaRef = useRef(null);
  var passwordValue = '';

  useEffect(() => {
    //register the delegate event
    //we set the timezone initially
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('timezone', momentTimezone.tz.guess())));
    window.addEventListener('globalMessageHidden', globalMessageHidden);
    window.addEventListener('resize', handleOnScreenSizeUpdate);

    return () => {
      ////unRegister the delegate event
      window.removeEventListener('globalMessageHidden', globalMessageHidden);
      window.removeEventListener('resize', handleOnScreenSizeUpdate);
    };
  }, []);

  //this function is a delegate event, and is fired when global message is hidden
  const globalMessageHidden = (e) => {
    console.log('>>>>>>> document', document.getElementsByName('orgName'));
    if (e.detail && e.detail.text.indexOf('Organisation with that name') > 0) {
      window.$('input[name="orgName"]').focus();
    } else if (e.detail && e.detail.text.indexOf('Waiting Area with that URL') > 0) {
      window.$('input[name="waitingAreaUrl"]').focus();
    }
  };
  const onSelfProvisionElementBlur = () => {
    dispatch(setWASelfProvisionFormTrim());
  };

  const firstNameChanged = (val) => {
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('firstName', val)));
  };
  const lastNameChanged = (val) => {
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('lastName', val)));
  };
  // emailChanged = (val) => {};
  const passwordChanged = (value) => {
    value = passwordValidator.removeInvalidChars(value);
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('password', value)));
  };
  const retypePasswordChanged = (val) => {
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('confirmPassword', val)));
  };

  const organisationNameChanged = (value) => {
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('organisationName', value)));
  };
  const organisationAbbreviationChanged = (value) => {
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('organisationAbbreviation', value)));
  };
  const waitingAreaNameChanged = (value) => {
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('waitingAreaName', value)));
  };
  const waitingAreaURLChanged = (value) => {
    // Replace all forward slashes with single forward slash
    value = value.replace(/[\/]{1,}/g, '/');
    dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('waitingAreaUrl', value)));
  };
  const agreeTermsAndConditionChanged = (value) => {
    dispatch(
      setWASelfProvisionForm(
        selfProvisionFormUpdated('agreeTermsAndCondition', !selfProvisionCreateForm.agreeTermsAndCondition)
      )
    );
  };
  const waNameFocusOut = (value) => {
    onSelfProvisionElementBlur();
    if (
      (!selfProvisionCreateForm.waitingAreaUrl || selfProvisionCreateForm.waitingAreaUrl.length == 0) &&
      value.length > 0 &&
      value.length <= 50
    ) {
      let shortUrl = getWaitingAreaNameToShortURL(value);
      dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('waitingAreaUrl', shortUrl)));
      setTimeout(() => {
        //we fire the handle change after 300 ms, as by that time the field values would have taken place
        //The validation does not kick in, so this helps
        waitingAreaRef.current.handleChange(shortUrl);
      }, 300);
    }
  };
  const orgNameFocusOut = (value) => {
    onSelfProvisionElementBlur();
    //on focus out we will have to copy it to org abb field if the conditions are met
    if (
      !(
        selfProvisionCreateForm.organisationAbbreviation && selfProvisionCreateForm.organisationAbbreviation.length > 0
      ) &&
      value.length > 2 &&
      value.length <= 16
    ) {
      dispatch(setWASelfProvisionForm(selfProvisionFormUpdated('organisationAbbreviation', value)));

      setTimeout(() => {
        //we fire the handle change after 300 ms, as by that time the field values would have taken place
        //The validation does not kick in, so this helps
        orgNameAbbRef.current.handleChange(value);
      }, 300);
    }
  };

  const selfProvisionFormUpdated = (property, value) => {
    return objectAssign({}, selfProvisionCreateForm, {
      [property]: value,
    });
  };

  const createSelfProvisionWASave = (e) => {
    let areThereErrors =
      forceValidation(undefined, undefined, 'selfProvisionWAForm') || !selfProvisionCreateForm.agreeTermsAndCondition;
    if (!areThereErrors && !e.target.classList.value.includes('disable')) {
      if (isWASelfProvisionSaving) {
        return; //already a reques is in process
      }
      let cb = (result, response, errorCode) => {
        setIsWASelfProvisionSaving(false);
        if (result) {
          // if (result) this.resetForm();
          const authRes = response.authenticationResponse;
          setAuthenticationDetails(authRes.sessionToken, authRes.serverTimeUtc, authRes.subscribeKey);
          dispatch(updateShowWelcomeWAMessage(true));
          redirectToInternalLink('/waiting-area/view-one/' + response.networkId);
        } else if (errorCode) {
          if (errorCode == 'OrgNameDuplicate') {
            window.$('input[name="orgName"]').focus();
          } else if (errorCode == 'WaitingAreaDuplicateShortUrl') {
            window.$('input[name="waitingAreaUrl"]').focus();
          }
        }
      };
      setIsWASelfProvisionSaving(true);
      let selfProvisionWA = selfProvisionCreateForm;
      // remove the trailing slash before saving
      let waitingAreaUrl = selfProvisionWA.waitingAreaUrl;
      selfProvisionWA.waitingAreaUrl = trimSlashAtTheEnd(waitingAreaUrl);
      dispatch(createSelfProvisionWA(selfProvisionWA, cb));
    }
  };

  const handleOnScreenSizeUpdate = (e) => {
    setIsOnMobileOrTablet(window.innerWidth >= window.styleVariable.computerMinWidth ? false : true);
  };

  let areThereErrors = !selfProvisionCreateForm.agreeTermsAndCondition;
  if (selfProvisionCreateForm.agreeTermsAndCondition) {
    //this is important as on checkbox check we want to see if there is any other error
    //passing false to the last param means we will nto display the error icons
    areThereErrors = forceValidation(undefined, undefined, 'selfProvisionWAForm', undefined, false);
  }

  let savebuttonClass =
    'mrtml ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull ';
  savebuttonClass = !areThereErrors ? savebuttonClass : savebuttonClass + ' disable termsAndConditionNotAccepted ';

  savebuttonClass = isWASelfProvisionSaving ? savebuttonClass + ' loading' : savebuttonClass;
  return (
    <div className="selfProvisionBackGround">
      <div className="ui form grid">
        <div className="ui eight wide computer only eight wide tablet only  column">
          <div className="bold mrbl color-white setUpText text-size-xl">{APP.LANGUAGE.SelfProvisionCreateWA.Setup}</div>
        </div>
        <div className="ui eight wide computer only eight wide tablet only column ">
          <img className="ui image platformLogoSelfProvision" src={window.APP.IMAGES.PlatformLogo} />
        </div>
        <div className="ui sixteen wide mobile only column ">
          <img className="ui image platformLogoSelfProvision" src={window.APP.IMAGES.ApplicationLogo} />
        </div>

        <div className="ui sixteen wide mobile only column">
          <div className="bold color-white text-size-l">{APP.LANGUAGE.SelfProvisionCreateWA.Setup}</div>
        </div>

        <div className="ui eight wide computer only eight wide tablet only sixteen wide mobile only column">
          <div className="bold mrbl color-white text-size-ml">{APP.LANGUAGE.SelfProvisionCreateWA.AccountDetails}</div>
          <div className="pdts">
            <ValidMe validmefor="nonLetterNonNumber" trim={true} group="selfProvisionWAForm">
              <Txt
                tabIndex="1"
                focusme="true"
                noTitle
                onBlur={onSelfProvisionElementBlur}
                value={selfProvisionCreateForm.firstName}
                onChange={firstNameChanged}
                placeholder={APP.LANGUAGE.SelfProvisionCreateWA.FirstName}
              />
            </ValidMe>
            <ValidMe validmefor="nonLetterNonNumber@optional" trim={true} group="selfProvisionWAForm">
              <Txt
                tabIndex="2"
                fieldClasses={spaceBWFields}
                noTitle
                onBlur={onSelfProvisionElementBlur}
                value={selfProvisionCreateForm.lastName}
                onChange={lastNameChanged}
                placeholder={APP.LANGUAGE.SelfProvisionCreateWA.LastName}
              />
            </ValidMe>

            <label className={'placeholder-label  no-bold color-placeholder mrtnull pdtnull emailLabel'}>
              {APP.LANGUAGE.SelfProvisionCreateWA.EmailAddress}
            </label>
            <div className="mrls color-white mrtl">{' ' + selfProvisionCreateForm.email}</div>

            <ValidMe
              validmefor="condition"
              getTemplatedError={(value) => {
                return passwordValidator.getErrorStyles(value || selfProvisionCreateForm.password);
              }}
              condition={(value) => {
                //if all password strength conditions are good, returns true. else returns false.
                var np = value || selfProvisionCreateForm.password;
                if (
                  !passwordValidator.verifyPasswordLength(np) ||
                  !passwordValidator.verifyPasswordStrengthLetter(np) ||
                  !passwordValidator.verifyPasswordStrengthNumber(np) ||
                  !passwordValidator.verifyPasswordStrengthSpecialCharacter(np)
                )
                  return false;
                else {
                  passwordValue = np;
                  return true;
                }
              }}
              group="selfProvisionWAForm"
            >
              <Txt
                tabIndex="3"
                fieldClasses="mrtmll "
                noTitle
                type="password"
                value={selfProvisionCreateForm.password}
                onChange={passwordChanged}
                placeholder={APP.LANGUAGE.SelfProvisionCreateWA.Password}
              />
            </ValidMe>
            <ValidMe
              validmefor="condition"
              validmemessagecondition={APP.LANGUAGE.ResetPassword.ConfirmPasswordNotSame}
              group="selfProvisionWAForm"
              condition={(value) => {
                return passwordValue == value;
              }}
            >
              <Txt
                tabIndex="4"
                fieldClasses={spaceBWFields}
                noTitle
                type="password"
                autoComplete="new-password"
                value={selfProvisionCreateForm.confirmPassword}
                onChange={retypePasswordChanged}
                placeholder={APP.LANGUAGE.SelfProvisionCreateWA.RetypePassword}
              />
            </ValidMe>
          </div>
        </div>
        <div className="ui eight wide computer only eight wide tablet only sixteen wide mobile only column">
          <div className="bold mrbl color-white text-size-ml">
            {APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaDetails}
          </div>
          <div className="pdts">
            <ValidMe
              validmefor="length@3-120"
              validmemessage={APP.LANGUAGE.Errors.OrgUnitInvalidLength}
              group="selfProvisionWAForm"
              trim={true}
            >
              <Txt
                tabIndex="5"
                noTitle
                maxLength={120}
                name="orgName"
                onBlur={orgNameFocusOut}
                value={selfProvisionCreateForm.organisationName}
                onChange={organisationNameChanged}
                placeholder={APP.LANGUAGE.SelfProvisionCreateWA.OrganisationName}
              />
            </ValidMe>
            <ValidMe
              validmefor="length@3-16"
              group="selfProvisionWAForm"
              validmemessage={APP.LANGUAGE.Errors.OrgAbbreviationLength}
            >
              <Txt
                labelRelativeRenderOnTop
                tabIndex="6"
                ref={orgNameAbbRef}
                trim={true}
                onBlur={onSelfProvisionElementBlur}
                noTitle
                maxLength={16}
                labelClasses="label-on-top-margin-top"
                value={selfProvisionCreateForm.organisationAbbreviation}
                onChange={organisationAbbreviationChanged}
                placeholder={
                  isOnMobileOrTablet
                    ? APP.LANGUAGE.SelfProvisionCreateWA.OrganisationAbbreviation
                    : APP.LANGUAGE.SelfProvisionCreateWA.OrganisationAbbreviationDesktop
                }
              />
            </ValidMe>
            <ValidMe
              validmefor="length@3-50"
              validmemessage={APP.LANGUAGE.Errors.WaitingAreaInValidNameLength}
              trim={true}
              group="selfProvisionWAForm"
            >
              <Txt
                tabIndex="7"
                maxLength={50}
                fieldClasses={spaceBWFields}
                noTitle
                value={selfProvisionCreateForm.waitingAreaName}
                onChange={waitingAreaNameChanged}
                onBlur={waNameFocusOut}
                placeholder={APP.LANGUAGE.SelfProvisionCreateWA.ServiceName}
              />
            </ValidMe>
            <label className=" placeholder-label no-bold div-like color-placeholder ">
              {APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaUrl}
            </label>
            <div className="center-flex display-flex  flex-wrap">
              <div className="title-sms small-margin color-white mrrxxs">{selfProvisionCreateForm.shortUrlDomain}</div>

              <ValidMe
                validmefor="shortURLPath"
                group="selfProvisionWAForm"
                fieldClasses="flex-grow-fill-rest mrtxxs"
                trim={true}
              >
                <Txt
                  tabIndex="8"
                  maxLength={128}
                  ref={waitingAreaRef}
                  onBlur={onSelfProvisionElementBlur}
                  noTitle
                  name="waitingAreaUrl"
                  notRenderPlaceholderAsTitle={true}
                  value={selfProvisionCreateForm.waitingAreaUrl}
                  onChange={waitingAreaURLChanged}
                  placeholder={APP.LANGUAGE.SelfProvisionCreateWA.WaitingAreaUrlPlaceHolder}
                />
              </ValidMe>
            </div>

            <div className="bold mrbl color-white mrtl text-size-ml">
              {APP.LANGUAGE.SelfProvisionCreateWA.CreateLabel}
            </div>

            <div>
              <Checkbox
                checked={selfProvisionCreateForm.agreeTermsAndCondition}
                onChange={agreeTermsAndConditionChanged}
                label={APP.LANGUAGE.SelfProvisionCreateWA.AgreeTermsLabel}
              />
              <span className="color-white">
                {' '}
                <a target="mgt-console-help" href="/terms">
                  {APP.LANGUAGE.SelfProvisionCreateWA.TermsCondition}
                </a>{' '}
                {APP.LANGUAGE.SelfProvisionCreateWA.And}{' '}
                <a target="mgt-console-help" href={APP.EXTERNAL_LINKS.Login.PrivacyPolicy}>
                  {APP.LANGUAGE.SelfProvisionCreateWA.PrivacyPolicy}
                </a>{' '}
                {APP.LANGUAGE.SelfProvisionCreateWA.acknowledge.replace(
                  '##PortalName##',
                  window.APP.CONFIGURATION.PORTAL.HostPlatformName
                )}
                <a target="mgt-console-help" href="/cookies">
                  {APP.LANGUAGE.SelfProvisionCreateWA.CookiePolicy}
                </a>
                {'.'}
              </span>
            </div>
            <button
              type="button"
              data-group="selfProvisionWAForm"
              onClick={createSelfProvisionWASave}
              className={savebuttonClass}
            >
              <i className="checkmark  icon" />
              <span className="smallOnMobile">{APP.LANGUAGE.SelfProvisionCreateWA.SignUpButton}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
